export const imageSize = (size = 62) => `width:${size}px;height:${size}px;`;
